module.exports = {
      id: "thump-usage",
      viewBox: "0 0 58 75",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#thump",
      toString: function () {
        return this.url;
      }
    }